<template>
  <div class="container full-height">
        <div class="row">
          <div class="col-12">
            <div class="title">{{ labelBox.title }}</div>
            <div v-show="labelBox.subtitle" class="subtitle">
              {{ labelBox.subtitle }}:
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
              <q-select
                :data-cy="labelDataCy"
                hide-selected
                multiple
                outlined
                v-model="selectedItems"
                :options="selectableItems"
                option-value="id"
                option-label="name"
                :label="labelBox.select"
                @input="setOptions"
              >
                <template
                  v-slot:option="{
                    itemProps,
                    itemEvents,
                    opt,
                    selected,
                    toggleOption,
                  }"
                >
                  <q-item v-bind="itemProps" v-on="itemEvents" active-class="multiple-select-active">
                    <q-item-section :side="true">
                      <q-checkbox
                        :value="selected"
                        @input="() => toggleOption(opt)"
                      />
                    </q-item-section>
                    <q-item-section
                      no-wrap
                      class="ellipsis multiple-select"
                      style="width: 100px"
                    >
                      <q-item-label>{{ opt.name }} </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
          </div>
        </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';

export default {
  components: {},
  mixins: [Message, Validation],
  props: {
    labelDataCy: String,
    labelBox: {
      type: Object,
      required: false,
      default: () => ({
        title: 'Opciones que la utilizan',
        subtitle: null,
        select: 'Añadir opción'
      })
    },
    selectedRow: { type: Array, required: true },
    selectableItems: { type: Array, required: true },
    endPoint: { type: String, required: true },
    eventName: { type: String, required: true }
  },
  data () {
    return {
      selectedItems: [],
      updatedSelectedItems: null
    };
  },
  methods: {
    async setOptions (event) {
      const itemGroup = event.length > 0 ? event[event.length - 1] : event;

      if (itemGroup.id) {
        const request = {
          controller: `${this.endPoint}${itemGroup.id}`,
          filter: {}
        };
        await this.$store
          .dispatch('PF/putSuit', request)
          .then(async () => {
            this.$eventHub.$emit(this.eventName, itemGroup.name);
          })
          .catch((err) => {
            this.showError(err.message);
          });
      } else {
        const itemToRemove = this.updatedSelectedItems.filter((el) => !event.includes(el));
        if (itemToRemove?.length > 0) {
          const request = {
            controller: `${this.endPoint}${itemToRemove[0]}`,
            filter: {}
          };
          await this.$store
            .dispatch('PF/deleteSuit', request)
            .then(async () => {
              this.$eventHub.$emit(this.eventName);
            })
            .catch((err) => {
              this.showError(err.message);
            });
        }
      }
    }
  },
  watch: {
    selectedRow: {
      handler () {
        if (Object.entries(this.selectableItems).length <= 0 || this.updatedSelectedItems) {
          return;
        }
        this.selectedItems = this.selectableItems
          .filter(item => this.selectedRow.map(row => row.name).includes(item.name))
          .map(o => o.id);
        this.updatedSelectedItems = this.selectedItems;
      },
      immediate: true
    }
  }
};
</script>
